module.exports = __webpack_public_path__ + "static/media/movieImg02.438dc19d.png";